// import React, { useState, useEffect } from 'react';
// import { apiService } from '../../constants/ApiService';
// import { useSelector } from 'react-redux';
// import {
//     Card,
//     Row,
//     Col,
//     CardTitle,
//     CardBody,
//     Button,
//     Form,
//     FormGroup,
//     Label,
//     Input,
//     FormText,
//     Table,
//     Alert,
//     CardFooter,
// } from 'reactstrap';
// import { BlobProvider, pdf } from '@react-pdf/renderer';
// import IDCardPdf from '../AdmissionMaster/IDCardPDF';
// import { useLocation } from 'react-router-dom';
// import { toast } from 'react-toastify';

// const SaveICardBatches = ({systemData}) => {
//     const location = useLocation();
//     const sessionData = useSelector((state) => state.sessionState);
//     const [search, setSearch] = useState("");
//     const [admissionList, setAdmissionList] = useState([]);
//     const [icardList, setIcardList] = useState([]);
//     const [icardPrintList, setIcardPrintList] = useState([]);

//     const [iCardBatchId, setICardBatchId] = useState(0);
//     const initialBatch = {id:iCardBatchId,session_year:sessionData.session_year}

//     const fetchAdmissionData = async () => {
//         try {
//             const queryParams = new URLSearchParams();

//             //queryParams.append("session", sessionData.session_year)
//             if (search) queryParams.append("search", search);

//             const response = await apiService.get(`api/Admission/GetAdmission?${queryParams.toString()}`);
//             if (response.status === true) {
//                 setAdmissionList(response.data)
//                 //console.log(response)
//             }
//         } catch (error) {
//             console.error("Error fetching data:", error);
//         }
//     };

//     const handleICardPrint = async () => {
//         try {
//           const admNoList = icardList.map((item) => item.admit_no);

//           // Create query string
//           const params = new URLSearchParams();
//           admNoList.forEach((no) => params.append("admNos", no));

//           const response = await apiService.get(`api/Admission/GetSpecifiedAdmNoList?${params.toString()}`);

//           if (response.status === true) {
//             console.log(systemData);
//             const blob = await pdf(
//               <IDCardPdf systemData={systemData} students={response.data} sessionYear={sessionData.session_year} />
//             ).toBlob();

//             const url = URL.createObjectURL(blob);
//             window.open(url, "_blank");
//           }
//         } catch (error) {
//           console.error("Error printing iCards:", error);
//         }
//       };

//     useEffect(() => {
//         fetchAdmissionData();
//         if(location.state)
//         {
//             const object = location.state
//             setICardBatchId(object.id);
//             const array = convertObjectToArray(object);
//             //console.log(object)
//             setIcardList(array);
//         }
//     }, [search]);

//     const addICard = (item) => {
//         const findSimilar = icardList.find((existingItem) => existingItem.admit_no === item.admit_no);
//         if(findSimilar)
//         {
//             toast.error("Admission no. already added in the queue");
//             return;
//         }
//         if (icardList.length === 10) {
//             toast.error("Max 10 I-Card can be made.");
//             return;
//         }
//         setIcardList([...icardList, item]);
//     }

//     const convertArrayToObject = (adm) => {
//         // const batchObject = { id: 0 };

//         adm.forEach((item, index) => {
//             initialBatch[`admit_no_${index + 1}`] = item.admit_no;
//         });

//         return initialBatch;
//     };

//     const convertObjectToArray = (batchObject) => {
//         const admNoArray = [];

//         for (let i = 1; i <= 10; i++) {
//           const key = `admit_no_${i}`;
//           if (typeof batchObject[key] === "string" && batchObject[key].trim() !== "") {
//             admNoArray.push(batchObject[key]);
//           }
//         }
//         const formatted = admNoArray.map(num => ({ admit_no: num }));

//         return formatted;
//     };

//     const addBatch = async () => {
//         console.log(icardList,"icardList");

//         const payload = convertArrayToObject(icardList);

//         let response;
//         //console.logpayload,"payload");

//         if(iCardBatchId === 0)
//         {
//             response = await apiService.post('api/I_Card/InsertICardBatch',payload);
//         }else{
//             response = await apiService.put('api/I_Card/UpdateICardBatch',payload)
//         }

//         //console.log(response)
//         if (response.status === true) {
//             alert(response.message);
//         }
//     };

//     const removeAdmNoFromBatch = (indexToRemove) => {
//         const updated = icardList.filter((_,index)=>index !== indexToRemove);
//         //console.logupdated,"updated")
//         setIcardList(updated);
//     }

//     return (
//         <>
//         <div className='bg-white pd-5 card-box mb-5 toolbar-row sticky-top border text-right mb-2'>
//         <button
//                             className="btn btn-warning"
//                             onClick={() => {handleICardPrint()}}
//                         >
//                             <i className="bi bi-printer" /> Print I-Cards
//                         </button> &nbsp;

//             <button className='btn btn-success' onClick={addBatch}>Save Batch</button>
//         </div>

//             <Row>

//                 <Col lg='8'>
//                     <Card className='card-box height-100-p pd-20 mb-20'>
//                         <CardTitle
//                             tag='h6'
//                             className='p-3 mb-0 d-flex align-items-center justify-content-between'
//                         >
//                             <div className='d-flex align-items-center'>
//                                 <i className='bi bi-card-text mr-2'></i>
//                                 Admission
//                             </div>

//                         </CardTitle>

//                         <div id="dateFilterForm" className="row g-3 align-items-end p-3">
//                             <div className="col-12 col-md-12">
//                                 <div className="input-group">
//                                     <span className="input-group-text"><i className="bi bi-search"></i></span>
//                                     <input type="text" onChange={(e) => { setSearch(e.target.value) }} className="form-control" placeholder="Search entries..." aria-label="Search" />
//                                 </div>
//                             </div>

//                         </div>

//                         <CardBody>
//                             <div className='table-responsive'>
//                                 <Table hover striped responsive>
//                                     <thead>
//                                         <tr>
//                                             <th>S.no.</th>
//                                             <th>Adm. No.</th>
//                                             <th>Student Name</th>
//                                             <th>Class & Sec</th>
//                                             <th>Father Name</th>
//                                             <th className='no-print'></th>

//                                             {/* <th>Delete</th> */}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {admissionList.length ? (
//                                             admissionList.map((item, index) => (
//                                                 <tr key={index}>
//                                                     <th scope='row'>{index + 1}</th>
//                                                     <td>{item.admit_no}</td>
//                                                     <td>{item.stud_name}</td>
//                                                     <td>{item.curr_class} {item.curr_sec}</td>
//                                                     <td>{item.f_name}</td>
//                                                     <td><i onClick={() => { addICard(item) }} style={{ cursor: "pointer" }} className='bi bi-chevron-double-right text-primary' /></td>

//                                                     {/* <td>
//                       <Button
//                         color='danger'
//                         size='bg'
//                         onClick={() => onHandleDeleteAdmission(item.id)}
//                       >
//                         Delete
//                       </Button>
//                     </td> */}
//                                                 </tr>
//                                             ))
//                                         ) : (
//                                             <>
//                                                 <tr>
//                                                     <td className='text-center' colSpan={8}>No data available</td>
//                                                 </tr>
//                                             </>
//                                         )}
//                                     </tbody>
//                                 </Table>
//                             </div>
//                         </CardBody>
//                         <CardFooter className='text-right'>
//                             (Showing latest 10 entries by default)
//                         </CardFooter>
//                     </Card>
//                 </Col>
//                 <Col lg="4">
//                     <Card className='card-box height-100-p pd-20 mb-20'>
//                         <CardTitle
//                             tag='h6'
//                             className='p-3 mb-0 d-flex align-items-center justify-content-between'
//                         > <div className='d-flex align-items-center'>
//                                 <i className='bi bi-person-badge'></i>
//                                 Printing Queue for I-Cards  (Max. 10)
//                             </div>

//                         </CardTitle>
//                         <CardBody>

//                             <div className='table-responsive'>
//                                 <Table hover striped responsive>
//                                     <thead>
//                                         <tr>
//                                             <th></th>
//                                             <th>S.no.</th>
//                                             <th>Adm. No.</th>

//                                             {/* <th>Delete</th> */}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {icardList.length ? (
//                                             icardList.map((item, index) => (
//                                                 <tr key={index}>
//                                                     <td><i onClick={() => { removeAdmNoFromBatch(index) }} style={{ cursor: "pointer" }} className='bi bi-chevron-double-left text-danger' /></td>

//                                                     <th scope='row'>{index + 1}</th>
//                                                     <td>{item.admit_no}</td>

//                                                 </tr>
//                                             ))
//                                         ) : (
//                                             <>
//                                                 <tr>
//                                                     <td className='text-center' colSpan={8}>No data available</td>
//                                                 </tr>
//                                             </>
//                                         )}
//                                     </tbody>
//                                 </Table>
//                             </div>
//                         </CardBody>
//                     </Card>
//                 </Col>

//             </Row>
//         </>
//     )
// }

// export default SaveICardBatches;

import React, { useState, useEffect } from 'react';
import { apiService } from '../../constants/ApiService';
import { useSelector } from 'react-redux';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
  Alert,
  CardFooter,
} from 'reactstrap';
import { BlobProvider, pdf } from '@react-pdf/renderer';
import IDCardPdf from '../AdmissionMaster/IDCardPDF';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';

const SaveICardBatches = ({ systemData }) => {
  const location = useLocation();
  const sessionData = useSelector((state) => state.sessionState);
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [search, setSearch] = useState('');
  const [admissionList, setAdmissionList] = useState([]);
  const [icardList, setIcardList] = useState([]);
  const [icardPrintList, setIcardPrintList] = useState([]);
  const [readyStudents, setReadyStudents] = useState([]);

useEffect(() => {
  const load = async () => {
    const data = await prepareStudents(icardList);
    setReadyStudents(data);
  };

  if (icardList?.length) load();
}, [icardList]);

  const [selectionData, setSelectionData] = useState({
    id: 0,
    vendor_id: '',
    branch_id: '',
    session_year: sessionData.session_year,
  });

  const [iCardBatchId, setICardBatchId] = useState(0);

  const getBase64FromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const prepareStudents = async (students) => {
  return await Promise.all(
    students.map(async (student) => {
     const url = `${process.env.REACT_APP_API_BASE_URL + student?.admission?.stud_img_path}`;
      //const url = `${"https://schoolapi.shivkms.com/" + student?.admission?.stud_img_path}`;

      let base64Image = "";
      try {
        base64Image = await getBase64FromUrl(url);
      } catch {}

      return {
        ...student,
        base64Image,
      };
    })
  );
};


  const fetchAdmissionData = async () => {
    try {
      const queryParams = new URLSearchParams();

      if (selectionData.vendor_id)
        queryParams.append('vendorId', selectionData.vendor_id);
      if (selectionData.branch_id)
        queryParams.append('branchId', selectionData.branch_id);

      if (search) queryParams.append('search', search);
      if (selectionData.vendor_id)
        queryParams.append('vendorId', selectionData.vendor_id);
      if (selectionData.branch_id)
        queryParams.append('branchId', selectionData.branch_id);

      if (search) queryParams.append('search', search);

    //   const response = await apiService.get(
    //     `api/Admission/GetAdmission?${queryParams.toString()}`,
    //   );
     const response = await apiService.get(
        `api/Enrollment/GetAllEnrollment?${queryParams.toString()}`,
      );
      
      if (response.status === true) {
        setAdmissionList(response.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleICardPrint = async () => {
    try {
      const admNoList = icardList.map((item) => item.admit_no);
      const enrIdList = icardList.map((item) => item.id);

      const params = new URLSearchParams();
      admNoList.forEach((no) => params.append('admNos', no));

      const response = await apiService.get(
        `api/Enrollment/GetSpecifiedEnrNoList?vendorId=${selectionData.vendor_id}&branchId=${selectionData.branch_id}&${params.toString()}`,
      );

      console.log(response , "i-cardsss")

      const imgData = await prepareStudents(response.data);

      if (response.status === true) {
        const blob = await pdf(
          <IDCardPdf
            //students={readyStudents}
            systemData={systemData}
            students={imgData}
            sessionYear={sessionData.session_year}
          />,
        ).toBlob();

        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      }
    } catch (error) {
      console.error('Error printing iCards:', error);
    }
  };

  useEffect(() => {
    if (location.state) {
      const object = location.state;
      setICardBatchId(object.id);
      setSelectionData((prev) => ({
        ...prev,
        ...object,
        id: object.id || 0,
        vendor_id: object.vendor_id || '',
        branch_id: object.branch_id || '',
        session_year: object.session_year || sessionData.session_year,
      }));

      const array = convertObjectToArray(object);
      setIcardList(array);
    }
  }, [location.state, sessionData.session_year]);

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      fetchAdmissionData();
    } else {
      setAdmissionList([]);
    }
  }, [
    search,
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  const addICard = (item) => {
    const findSimilar = icardList.find(
      (existingItem) => existingItem.admit_no === item.admit_no,
    );
    if (findSimilar) {
      toast.error('Admission no. already added in the queue');
      return;
    }
    if (icardList.length === 10) {
      toast.error('Max 10 I-Card can be made.');
      return;
    }
    setIcardList([...icardList, item]);
  };

  const convertArrayToObject = (adm) => {
    const batchObject = {
      id: iCardBatchId,
      vendor_id: selectionData.vendor_id || 0,
      branch_id: selectionData.branch_id || 0,
      session_year: sessionData.session_year,
    };

    adm.forEach((item, index) => {
      batchObject[`admit_no_${index + 1}`] = item.admit_no;
    });

    return batchObject;
  };

  const convertObjectToArray = (batchObject) => {
    const admNoArray = [];

    for (let i = 1; i <= 10; i++) {
      const key = `admit_no_${i}`;
      if (
        typeof batchObject[key] === 'string' &&
        batchObject[key].trim() !== ''
      ) {
        admNoArray.push(batchObject[key]);
      }
    }

    const formatted = admNoArray.map((num) => ({ admit_no: num }));
    return formatted;
  };

  const addBatch = async () => {
    if (
      isSuperAdmin &&
      (!selectionData.vendor_id || selectionData.vendor_id <= 0)
    ) {
      toast.error('Please select Vendor');
      return;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!selectionData.branch_id || selectionData.branch_id <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    const payload = convertArrayToObject(icardList);

    let response;

    if (iCardBatchId === 0) {
      response = await apiService.post('api/I_Card/InsertICardBatch', payload);
    } else {
      response = await apiService.put('api/I_Card/UpdateICardBatch', payload);
    }

    if (response.status === true) {
      toast.success(response.message);
    }
  };

  const removeAdmNoFromBatch = (indexToRemove) => {
    const updated = icardList.filter((_, index) => index !== indexToRemove);
    setIcardList(updated);
  };

  return (
    <>
      <div className='bg-white pd-5 card-box mb-5 toolbar-row sticky-top border text-right mb-2'>
       
       {iCardBatchId > 0 && <button
          className='btn btn-danger mr-2'
          onClick={() => {
            handleICardPrint();
          }}
        >
          <i className='bi bi-printer' /> Print I-Cards
        </button>
       }
        <button className='btn btn-success' onClick={addBatch}>
        
          <i className='bi bi-check-circle' />   Save Batch
        </button>
        &nbsp;
        <Link className='btn btn-warning' to="/IcardBatches">
        
          <i className='bi bi-arrow-left' />   Back
        </Link>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Row>
        <Col lg='8'>
          <Card className='card-box height-100-p pd-20 mb-20'>
            <CardTitle
              tag='h6'
              className='p-3 mb-0 d-flex align-items-center justify-content-between'
            >
              <div className='d-flex align-items-center'>
                <i className='bi bi-card-text mr-2'></i>
                Admission
              </div>
            </CardTitle>

            <div id='dateFilterForm' className='row g-3 align-items-end p-3'>
              <div className='col-12 col-md-12'>
                <div className='input-group'>
                  <span className='input-group-text'>
                    <i className='bi bi-search'></i>
                  </span>
                  <input
                    type='text'
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    className='form-control'
                    placeholder='Search entries...'
                    aria-label='Search'
                  />
                </div>
              </div>
            </div>

            <CardBody>
              <div className='table-responsive'>
                <Table hover striped responsive>
                  <thead>
                    <tr>
                      <th>S.no.</th>
                      <th>Adm. No.</th>
                      <th>Student Name</th>
                      <th>Class & Sec</th>
                      <th>Father Name</th>
                      <th className='no-print'></th>
                    </tr>
                  </thead>
                  <tbody>
                    {admissionList.length ? (
                      admissionList.map((item, index) => (
                        <tr key={index}>
                          <th scope='row'>{index + 1}</th>
                          <td>{item.admit_no}</td>
                          <td>{item.student_name}</td>
                          <td>
                            {item.course_name} {item.curr_sec}
                          </td>
                          <td>{item.admission?.f_name}</td>
                          <td>
                            <i
                              onClick={() => {
                                addICard(item);
                              }}
                              style={{ cursor: 'pointer' }}
                              className='bi bi-chevron-double-right text-primary'
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className='text-center' colSpan={8}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
            <CardFooter className='text-right'>
              (Showing latest 10 entries by default)
            </CardFooter>
          </Card>
        </Col>

        <Col lg='4'>
          <Card className='card-box height-100-p pd-20 mb-20'>
            <CardTitle
              tag='h6'
              className='p-3 mb-0 d-flex align-items-center justify-content-between'
            >
              <div className='d-flex align-items-center'>
                <i className='bi bi-person-badge'></i>
                Printing Queue for I-Cards (Max. 10)
              </div>
            </CardTitle>

            <CardBody>
              <div className='table-responsive'>
                <Table hover striped responsive>
                  <thead>
                    <tr>
                      <th></th>
                      <th>S.no.</th>
                      <th>Adm. No.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {icardList.length ? (
                      icardList.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <i
                              onClick={() => {
                                removeAdmNoFromBatch(index);
                              }}
                              style={{ cursor: 'pointer' }}
                              className='bi bi-chevron-double-left text-danger'
                            />
                          </td>
                          <th scope='row'>{index + 1}</th>
                          <td>{item.admit_no}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className='text-center' colSpan={3}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SaveICardBatches;
